import Swiper, {Navigation, Pagination, Autoplay, EffectFade, Thumbs, EffectCoverflow} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs, EffectCoverflow]);

export const generateSlider = (selector, settings) => {
  if ($(selector).length) {
    let slider = new Swiper(selector, settings);
    setTimeout(() => {
      if ($(selector).length) {
        if (slider.length) {
          slider.forEach(single => single.update());
          if ($('.gallery-thumbs .image-box').length < 5) {
            $('.gallery-thumbs').addClass('no-nav');
          }
        }
      }
    }, 1000);
  }
};

export const toggleFAQ = (elements) => {
  if (elements.length) {
    elements.each(function () {
      let that = $(this);
      that.on('click', function () {
        $(this).toggleClass('open');
        $(this).next().slideToggle();
        elements.not($(this)).removeClass('open');
        elements.next().not($(this).next()).slideUp();
      });
    });
  }
};

export const toggleSelect = (btn,els) => {

  if (btn.length) {
    btn.each(function () {
      let that = $(this);
      that.on('click', function () {
        $(this).toggleClass('open');
        $(this).next().slideToggle(0);
        btn.not($(this)).removeClass('open');
        btn.next().not($(this).next()).slideUp(0);
      });
    });
    els.each(function () {
      $(this).on('click', function () {
        let val = $(this).text();
        let dataVal = $(this).find('p').attr('data-type-value');
        let dataType = $(this).find('p').attr('data-type');
        $(this).parent().parent().prev().find('p span').text(val).attr('data-type-value',dataVal).attr('data-type',dataType)
        $(this).parent().find('li').removeClass('current');
        $(this).addClass('current');
        btn.removeClass('open')
        btn.next().slideUp(0);
      })
    })
  }
};

export const playVideo = (selector, parent, iframe) => {
  selector.on('click', function () {
    let link = $(this).attr('data-url');
    parent.addClass('play');
    iframe.attr('src', (link += '?autoplay=1'));
  });
};

export const playGameVideo = (selector, parent, iframe) => {
  selector.each(function () {
    $(this).on('click', function () {
      let link = $(this).attr('data-url');
      parent.addClass('play');
      iframe.attr('src', link += '?autoplay=1');
    });
  });
};

export const playSingleGame = (selector, parent, iframe) => {
  selector.each(function () {
    $(this).on('click', function () {
      let link = $(this).attr('data-url');
      $(parent).addClass('play');
      iframe.attr('src', link);
    });
  });
};

export const playVideoPop = (btn, elements, iframe) => {
  btn.on('click', function () {
    let link = $(this).attr('data-url');
    $(elements).addClass('active');
    iframe.attr('src', (link += '?autoplay=1'));
  });
};

export const smoothScroll = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const closePop = (btn, closedElements) => {
  btn &&
    btn.on('click', () => {
      closedElements.removeClass('active play');
      $(' .custom-pop iframe').attr('src', 'about:blank');
    });
};

export const loadMoreLogic = (button, num = 4, slideNum = 2) => {
  button.each(function () {
    $(this).on('click', function () {
      let boxes = $(this).parent().prev().find('.box:hidden');
      boxes.slice(0, num).slideDown();
      console.log(boxes.length);
      if (boxes.length <= slideNum) {
        $(this).parent().slideUp();
      }
    });
  });
};

export const loadMoreJackpotGamesLogic = (button, num = 4, slideNum = 2) => {
  if(button.length) {
    button.each(function () {
      $(this).on('click', function () {
        let boxes = $(this).parent().parent().find('.box:hidden');
        boxes.slice(0, num).slideDown();
        console.log(boxes.length);
        if (boxes.length <= slideNum) {
          $(this).parent().slideUp();
        }
      });
    });
  }

};

export const doubleClickLinks = (element) => {
  element &&
    element.each(function () {
      $(this).on(
        'click',
        function () {
          return false;
        }.dblclick(function () {
          window.location = this.href;
          return false;
        })
      );
    });
};



// WEBPACK FOOTER //
// ./scripts/exports/events.js